import { all, call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import api from '../../services/api';
import {
  LIST_DISCURSIVE_ASSESSMENTS_REQUEST,
  GET_DISCURSIVE_ASSESSMENT_REQUEST,
  ADD_DISCURSIVE_ASSESSMENT_REQUEST,
  EDIT_DISCURSIVE_ASSESSMENT_REQUEST,
  EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_REQUEST,
  LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST,
  LIST_DISCURSIVE_QUESTION_FIELDS_REQUEST,
  VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST,
  VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_REQUEST,
  SEND_DISCURSIVE_ASSESSMENT_REQUEST,
} from '../actions';
import {
  addDiscursiveAssessmentError,
  addDiscursiveAssessmentSuccess,
  editActiveDiscursiveAssessmentError,
  editActiveDiscursiveAssessmentSuccess,
  editDiscursiveAssessmentError,
  editDiscursiveAssessmentSuccess,
  getDiscursiveAssessmentError,
  getDiscursiveAssessmentSuccess,
  listDiscursiveAssessmentSubjectsError,
  listDiscursiveAssessmentSubjectsSuccess,
  listDiscursiveAssessmentsError,
  listDiscursiveAssessmentsSuccess,
  listDiscursiveQuestionFieldsError,
  listDiscursiveQuestionFieldsSuccess,
  sendDiscursiveAssessmentError,
  sendDiscursiveAssessmentSuccess,
  vinculateDiscursiveAssessmentQuestionsError,
  vinculateDiscursiveAssessmentQuestionsSuccess,
  vinculateDiscursiveAssessmentSubjectsError,
  vinculateDiscursiveAssessmentSubjectsSuccess,
} from './actions';

function* listDiscursiveAssessments() {
  try {
    const response = yield call(api.get, 'discursive-assessments/classes');
    yield put(listDiscursiveAssessmentsSuccess(response.data.data));
  } catch (error) {
    yield put(listDiscursiveAssessmentsError(error));
  }
}

function* getDiscursiveAssessmentById({ payload }) {
  try {
    const response = yield call(api.get, `discursive-assessments/${payload.id}`);
    yield put(getDiscursiveAssessmentSuccess(response.data.data));
  } catch (error) {
    yield put(getDiscursiveAssessmentError(error));
  }
}

function* addDiscursiveAssessment({ payload }) {
  try {
    const res = yield call(api.post, 'discursive-assessments', payload.discursiveAssessment);
    if (!res.response) {
      yield put(addDiscursiveAssessmentSuccess(res.data.data));
    } else {
      yield put(addDiscursiveAssessmentError(res.response.data));
    }
  } catch (error) {
    yield put(addDiscursiveAssessmentError(error));
  }
}

function* editDiscursiveAssessment({ payload }) {
  try {
    const res = yield call(
      api.put,
      `discursive-assessments/${payload.discursiveAssessment.id}`,
      payload.discursiveAssessment
    );
    if (!res.response) {
      yield put(editDiscursiveAssessmentSuccess(res.data.data));
    } else {
      yield put(editDiscursiveAssessmentError(res.response.data));
    }
  } catch (error) {
    yield put(editDiscursiveAssessmentError(error));
  }
}

function* editActiveDiscursiveAssessment({ payload }) {
  try {
    const response = yield call(
      api.put,
      `discursive-assessments/${payload.id}/activate/${payload.active ? '1' : '0'}`
    );
    yield put(editActiveDiscursiveAssessmentSuccess(payload.id, response.data.data.active));
  } catch (error) {
    yield put(editActiveDiscursiveAssessmentError(error));
  }
}

function* listDiscursiveAssessmentSubjects() {
  try {
    const response = yield call(api.get, 'exam-subjects');
    yield put(listDiscursiveAssessmentSubjectsSuccess(response.data.data));
  } catch (error) {
    yield put(listDiscursiveAssessmentSubjectsError(error));
  }
}

function* listDiscursiveQuestionFields() {
  try {
    const response = yield call(api.get, 'discursive-question-fields');
    yield put(listDiscursiveQuestionFieldsSuccess(response.data.data));
  } catch (error) {
    yield put(listDiscursiveQuestionFieldsError(error));
  }
}

function* vinculateDiscursiveAssessmentSubjects({ payload }) {
  try {
    yield call(api.post, 'discursive-assessments/subjects', payload.subjects);
    const response = yield call(
      api.get,
      `discursive-assessments/${payload.subjects.discursive_assessment_id}/subjects`
    );
    yield put(vinculateDiscursiveAssessmentSubjectsSuccess(response.data.data));
  } catch (error) {
    yield put(vinculateDiscursiveAssessmentSubjectsError(error));
  }
}

function* vinculateDiscursiveAssessmentQuestions({ payload }) {
  try {
    yield call(api.post, 'discursive-assessments/subjects/questions', payload.questions);
    yield put(
      vinculateDiscursiveAssessmentQuestionsSuccess(
        payload.questions,
        payload.isLastSubject
      )
    );
  } catch (error) {
    yield put(vinculateDiscursiveAssessmentQuestionsError(error));
  }
}

function* sendDiscursiveAssessment({ payload }) {
  try {
    const res = yield call(api.post, `discursive-assessments/${payload.id}/sent`);
    if (!res.response) {
      toast.success(res.data.message);
      yield put(sendDiscursiveAssessmentSuccess(payload.id, res.data.data.pivot.sent_at));
    } else {
      yield put(sendDiscursiveAssessmentError(res.response.data));
    }
  } catch (error) {
    const data = error.response?.data;
    const validationMsg = data?.errors?.discursive_assessment?.[0];
    const message = validationMsg || data?.error || data?.message || 'Falha ao enviar a avaliação discursiva.';
    toast.error(message);
    yield put(sendDiscursiveAssessmentError(data || error));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(LIST_DISCURSIVE_ASSESSMENTS_REQUEST, listDiscursiveAssessments),
    takeLatest(GET_DISCURSIVE_ASSESSMENT_REQUEST, getDiscursiveAssessmentById),
    takeLatest(ADD_DISCURSIVE_ASSESSMENT_REQUEST, addDiscursiveAssessment),
    takeLatest(EDIT_DISCURSIVE_ASSESSMENT_REQUEST, editDiscursiveAssessment),
    takeLatest(
      EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_REQUEST,
      editActiveDiscursiveAssessment
    ),
    takeLatest(
      LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST,
      listDiscursiveAssessmentSubjects
    ),
    takeLatest(
      LIST_DISCURSIVE_QUESTION_FIELDS_REQUEST,
      listDiscursiveQuestionFields
    ),
    takeLatest(
      VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST,
      vinculateDiscursiveAssessmentSubjects
    ),
    takeLatest(
      VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_REQUEST,
      vinculateDiscursiveAssessmentQuestions
    ),
    takeLatest(SEND_DISCURSIVE_ASSESSMENT_REQUEST, sendDiscursiveAssessment),
  ]);
}
